import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfdHRcRGJYWUVzX0RWYEo=');


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
